import React, { useEffect } from "react";
import "./Hives.css";
import rakshith from "../../Assets/hive/rak1.webp";
import meghana from "../../Assets/hive/meghana.webp";
import swati from "../../Assets/hive/swat.webp";
import parinitha from "../../Assets/hive/pranitha.webp";
import bhavani from "../../Assets/hive/bhavani.webp";
import gear from "../../Assets/gear.svg";
import compass from "../../Assets/compass.svg";
import har from "../../Assets/hive/harshita.webp";
import bhoomika from "../../Assets/hive/bhoomika.jpg";
import tanmayi from "../../Assets/hive/tanmayi.jpg";
import rak from "../../Assets/hive/rakshith-bnw.jpeg";
import eshwar from "../../Assets/hive/eshwar.jpeg";
import ish from "../../Assets/hive/ishwar.webp";
import shash from "../../Assets/hive/shashwatha.jpeg";
import neha from "../../Assets/hive/neha.jpeg";
import { Col, Container, Row } from "react-bootstrap";
function Hives() {
  useEffect(() => {
    let target = window.location.hash;
    target && document.querySelector(target).scrollIntoView();
  }, []);

  return (
    <div className="hives">
      <div id="hives" className="title">
        OUR HIVE
      </div>
      <Container className="rowContainer">
        <Row className="note">
          <Col lg={4} className="colm">
            <div className="imgContainer">
              <img
                src={rakshith}
                width={290}
                height={290}
                alt="Rakshith"
                style={{ borderRadius: "40px" }}
              />
              <div className="name">Ar. Rakshith R</div>
              <div className="caps">Founder and Principal Architect</div>
              <div className="degree">
                B.Arch, School of Planning and Architecture
              </div>
              <div className="degree">University Of Mysore</div>
            </div>
          </Col>
          <div className="vectors">
            <div className="gear">
              <img
                src={gear}
                width={300}
                height={300}
                alt="gear"
                className="gear1"
              ></img>
              <img
                src={gear}
                width={300}
                height={300}
                alt="gear"
                className="gear2"
              ></img>
            </div>
          </div>
          <Col lg={8} className="noteContainer">
            <div className="noteTitle">Note from the Founder</div>
            <div className="content">
              In our architecture studio, we believe in keeping things simple.
              We think simplicity is important because it helps us focus on what
              really matters in our designs. It's not about making things boring
              or plain, but about finding a balance that makes our buildings
              functional, beautiful, and easy to understand.
              <br />
              We pay attention to how spaces flow, use materials wisely, and
              care about the environment. Our goal is to create buildings that
              are easy to use, look good, and stand strong for a long time.
              <br /> Simplifying our approach helps us connect with our clients'
              needs and make a positive impact on the places where people live
              and work.
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={rak}
                width={150}
                height={150}
                alt="Eshwar"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Rakshith R</div>
              <div className="caps">Founder and Principal Architect</div>
              <div className="degree">B.Arch, SPA_UOM</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>
          <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={eshwar}
                width={150}
                height={150}
                alt="Eshwar"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Eshwar Chengappa</div>
              <div className="caps">Associate Architect</div>
              <div className="degree">B.Arch, SPA-UOM</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>

          <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={shash}
                width={150}
                height={150}
                alt="Shaswatha M K"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Shaswatha M K</div>
              <div className="caps">Junior Architect</div>
              <div className="degree">B.Arch, SIT</div>
              <div className="degree">Tumkur</div>
            </div>
          </Col>
          <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={neha}
                width={150}
                height={150}
                alt="Ar. Neha S Kalshetty"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Neha S Kalshetty</div>
              <div className="caps">Associate Architect</div>
              <div className="degree">M.Arch, SPA_UOM</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>
          <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={tanmayi}
                width={150}
                height={150}
                alt="Ar. Tanmayi R Koushik"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Tanmayi R Koushik</div>
              <div className="caps">Junior Architect</div>
              <div className="degree">B.arch , MSA</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>
          <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={bhoomika}
                width={150}
                height={150}
                alt="bhoomika"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Bhoomika SJ</div>
              <div className="caps">Junior Architect</div>
              <div className="degree">B.arch, M.S.R.I.T</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hives;
